import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import isRequiredForA11y from 'prop-types-extra/lib/isRequiredForA11y';
import elementType from 'prop-types-extra/lib/elementType';
import splitComponentProps from '../bootstrap/utils/splitComponentProps';
import Dropdown from '../Dropdown/Dropdown.js';
class DropdownButton extends React.Component {
  render() {
    const {
      bsSize,
      bsStyle,
      title,
      children,
      ...props
    } = this.props;
    const [dropdownProps, toggleProps] = splitComponentProps(props, Dropdown.ControlledComponent);
    return /*#__PURE__*/React.createElement(Dropdown, Object.assign({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), /*#__PURE__*/React.createElement(Dropdown.Toggle, Object.assign({}, toggleProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), /*#__PURE__*/_jsx(Dropdown.Menu, {}, void 0, children));
  }
}
export default DropdownButton;